/* eslint camelcase: 0 */
import { TalkTemplate, TalkTemplateRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { ITalkTemplateProps, EmptyTalkTemplatePropsFactory } from '@/entities/TalkTemplate'

export const toTalkTemplateProps = (props: TalkTemplate | null | undefined): ITalkTemplateProps => {
  if (!props) {
    return EmptyTalkTemplatePropsFactory()
  }

  const { id, title, body, order, created_at, updated_at } = props

  return EmptyTalkTemplatePropsFactory({
    id,
    title,
    body,
    order,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toTalkTemplateRequest = (props: ITalkTemplateProps): TalkTemplateRequest => {
  const { title, body } = props
  return {
    title: title!,
    body: body!
  }
}
